import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import UserCard from 'flarum/forum/components/UserCard';
import TypeFactory from './types/TypeFactory';
import Stream from 'flarum/common/utils/Stream';
export default function mutateUserHero() {
  extend(UserCard.prototype, 'infoItems', function (items) {
    const user = this.attrs.user;
    const answers = app.forum.attribute('canViewMasquerade') ? user.bioFields() || [] : [];
    answers.forEach(answer => {
      const field = answer.field();
      const type = TypeFactory.typeForField({
        field,
        stream: Stream(answer.content() || '')
      });
      const answerField = type.answerField();
      if (answerField) {
        items.add(`masquerade-bio-${field.id()}`, answerField);
      }
    });
  });
}